// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cells_cell__3BwIC","first":"Cells_first__1-ovZ","last":"Cells_last__3hvC-"};